// extracted by mini-css-extract-plugin
module.exports = {"social-links":"SocialLinks_social-links__F5apu","social-link":"SocialLinks_social-link__nCqCd","social-icon":"SocialLinks_social-icon__h6Gg4"};